import { HpError } from '@avantia/logging-and-errors';
import { HpUiEventData } from '@avantia/questionset-model';
import {
  HpBespokeCustomEventHandler,
  HpBindFieldChangeEventsProps,
  HpCustomEventHandler,
  HpTriggerBespokeCustomEventFunction,
  HpTriggerCommonEventProps,
  HpTriggerGeneralActionProps
} from '../engineClient/actions/eventActionTypes';
import { registerBespokeCustomEvent } from '../engineClient/actions/eventActions';
import { HpBindFieldChangeEventsPropsExtensionFunction } from '../engineClient/tools/eventLogger';
import { getEventDetail } from '../engineClient/tools/utilities';

export const hpClaimsAlertEventType = 'hp-claims-alert-displayed';

export type HpTriggerClaimStartedEventProps = HpClaimStartedEventProps & HpTriggerCommonEventProps;

interface HpClaimStartedEventProps {
  agentName: string | undefined;
}

let triggerClaimStartedEvent: HpTriggerBespokeCustomEventFunction<HpTriggerClaimStartedEventProps> | undefined;

export const extendEventLogger: HpBindFieldChangeEventsPropsExtensionFunction = (
  props,
  { addEventRecord, getCookieData }
): HpBindFieldChangeEventsProps => {
  const { onGeneralAction: onGeneralActionOriginal } = props;
  const onGeneralAction = (props: HpCustomEventHandler<HpTriggerGeneralActionProps>) => {
    const { data, customEvent } = props;
    const event = data.getEvent();
    const { target, eventType } = getEventDetail(event);
    if (eventType === hpClaimsAlertEventType) {
      const { textContent, id } = target || {};
      if (!textContent) {
        throw new HpError(`Unable to trigger alert event as the alert element with id ${id} does not contain text.`);
      }

      const eventData: HpUiEventData = {
        ...getCookieData(),
        eventType,
        targetId: target ? target.id : '',
        timeStamp: customEvent.timeStamp,
        value: textContent
      };

      addEventRecord(eventData);
    } else {
      onGeneralActionOriginal(props);
    }
  };

  return { ...props, onGeneralAction } as HpBindFieldChangeEventsProps;
};

export function registerClaimStartedEvent(
  onEventAction: (props: HpBespokeCustomEventHandler<HpTriggerClaimStartedEventProps, string>) => void
): void {
  triggerClaimStartedEvent = registerBespokeCustomEvent<HpTriggerClaimStartedEventProps>({
    eventType: 'hp-claim-started',
    onEventAction
  });
}

export { triggerClaimStartedEvent };
